Wee.fn.make('baseCart', {
	model: function() {
		var saleTotal = 0,
			regularTotal = 0,
			discountTotal = 0,
			quantity = 0,
			discounts,
			regularTotalStr,
			saleTotalStr,
			discountsStr,
			items;

		if (! this.store) {
			this.store = Wee.fn.storage();
		}

		items = this.store.get('items');

		// Only if price and sale price are shown on entry page
		for (var i = 0; i < items.length; i += 1) {
			if (items[i].productPrice) {
				var productPrice = items[i].productPrice;

				productPrice = productPrice.replace(/,/g, '');

				items[i].regularPrice = parseFloat(productPrice) * parseInt(items[i].productQuantity);

				regularTotal += parseFloat(items[i].regularPrice);
			}

			if (items[i].productSalePrice) {
				items[i].salePrice = true;

				discounts = items[i].productSalePrice;

				discounts = discounts.replace(/,/g, '');

				items[i].discountedPrice = parseFloat(discounts) * parseInt(items[i].productQuantity);

				discountTotal += parseFloat(items[i].discountedPrice);
			} else {
				items[i].salePrice = false;
				discountTotal += 0;
			}

			if (items[i].productQuantity) {
				quantity += parseInt(items[i].productQuantity);
			}
		}

		saleTotal = parseFloat(regularTotal - discountTotal);
		regularTotalStr = regularTotal.toFixed(2);
		discountsStr = discountTotal.toFixed(2);
		saleTotalStr = saleTotal.toFixed(2);

		if (regularTotalStr.length > 6) {
			regularTotal = this.formatPrice(regularTotalStr);
		} else {
			regularTotal = regularTotalStr;
		}

		if (saleTotalStr.length > 6) {
			saleTotal = this.formatPrice(saleTotalStr);
		} else {
			saleTotal = saleTotalStr;
		}

		if (discountsStr.length > 6) {
			discounts = this.formatPrice(discountsStr);
		} else {
			discounts = discountsStr;
		}

		return {
			items: items,
			discounts: discounts,
			discountedTotal: saleTotal,
			quotePricing: $.get('showPricing', false),
			total: regularTotal
		};
	},

	formatPrice: function(totalType) {
		var decimal = totalType.indexOf('.'),
			integer = totalType.slice(0, decimal),
			hundreds = totalType.slice(integer.length - 3, integer.length),
			thousands = totalType.slice(0, integer.length - 3),
			endSub = totalType.slice(decimal, totalType.length);

		totalType = thousands + ',' + hundreds + endSub;

		return totalType;
	}
}, {
	/**
	 * Sync items in session storage and data store
	 *
	 * @private
	 */
	syncItems: function(app, key, data) {
		app.$set(key, data);
		this.$public.store.set(key, data);
	}
});